/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_Q5Inputs */

const en_pc_alt_faq_q5 = /** @type {(inputs: Pc_Alt_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which alternatives keep my files off the internet?`)
};

const zh_pc_alt_faq_q5 = /** @type {(inputs: Pc_Alt_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哪些替代品不会把我的文件传到网上？`)
};

/**
* | output |
* | --- |
* | "Which alternatives keep my files off the internet?" |
*
* @param {Pc_Alt_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_q5 = /** @type {((inputs?: Pc_Alt_Faq_Q5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_Q5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_q5(inputs)
	return zh_pc_alt_faq_q5(inputs)
});
export { pc_alt_faq_q5 as "pc.alt.faq.q5" }